import { render } from "./DbFavoriteFormDialog.vue?vue&type=template&id=c60055e0"
import script from "./DbFavoriteFormDialog.vue?vue&type=script&lang=js"
export * from "./DbFavoriteFormDialog.vue?vue&type=script&lang=js"

import "./DbFavoriteFormDialog.vue?vue&type=style&index=0&id=c60055e0&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__